import styled from "styled-components";
import { colors, params } from "../../../theme/Params";

export const ScMarkupBar = styled.div`
  background-color: #f9f9f9;
  border-bottom-left-radius: ${params.containerBlockRadius};
  border-bottom-right-radius: ${params.containerBlockRadius};

  padding: 10px 32px !important;

  button.icon {
    svg {
      fill: #6e6b7b;
    }

    &.info {
      margin-left: 8px;

      & svg {
        fill: none;
      }
    }

    height: 32px;
    width: 34px;
    background: none;
    border-radius: 0;
    padding: 5px;
    border-top: none !important;
    border-bottom: none !important;
    border-left: 2px solid ${colors.grey20};
    border-right: 2px solid ${colors.background};

    & + .icon {
      border-left: 2px solid ${colors.background};
    }

    &.active,
    &:hover {
      background-color: ${colors.beeline};
      border-radius: 5px;
      border-left: 2px solid ${colors.beeline};
      border-right: 2px solid ${colors.beeline};

      & + .icon {
        border-right: 2px solid ${colors.grey20};

        &:hover {
          border-right: 2px solid ${colors.beeline};
        }
      }
    }
  }

  .tab-left {
  }

  & .tab-nav {
    & * {
      border: none !important;
    }
  }

  .tab-right {
    button.icon {
      &:first-of-type {
        border-left: 2px solid ${colors.grey20};
        border-right: 2px solid ${colors.grey20};
      }

      &:hover {
        border-right: 2px solid ${colors.beeline};
        border-left: 2px solid ${colors.beeline};

        & + .icon {
          border-left: 2px solid ${colors.background};
        }
      }

      &:last-of-type {
        border-left: 2px solid ${colors.grey20};
        border-right: 2px solid ${colors.grey20};

        &:hover {
          border-left: 2px solid ${colors.beeline};
          border-right: 2px solid ${colors.beeline};
        }
      }
    }

    .zoom {
      font-weight: 500;
      display: inline-block;
      font-size: 12px;
      line-height: 15px;
      color: ${colors.grey50};
      width: 62px;
      padding-left: 15px;
      padding-right: 15px;

      & + button {
        &:hover {
          border: 2px solid ${colors.beeline};
        }
      }
    }

    .steps {
      display: flex;
      justify-content: space-between;
      padding-left: 30px;

      & span {
        padding-left: 4px;
        padding-right: 4px;
      }

      & > button {
        display: flex;
        justify-content: space-between;
        padding-left: 10px;
        background: none;
        border: none;

        &:disabled {
          .icon-container {
            opacity: 0.25;
          }
        }

        .icon-container {
          width: 16px;
          height: 16px;
          display: inline-block;

          &:last-child {
            transform: rotateY(180deg);
          }
        }
      }
    }
  }

  & > .markup-control-container {
    display: flex;
    justify-content: space-between;

    & > .control-items {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .modal-info {
    position: fixed;
    display: flex;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;

    & > .modal-info-content {
      position: relative;
      background: white;
      border: 2px solid #bfbfc0;
      border-radius: 8px;
      padding: 48px 24px 16px 32px;
      box-shadow: 4px 4px 24px #bfbfc0;
      width: 60%;
      height: 85%;
      top: 5%;

      & > .close-modal {
        position: absolute;
        font-size: 48px;
        font-weight: bold;
        transition: 0.3s;
        cursor: pointer;
        top: -1%;
        left: 95%;
        color: rgba(26, 28, 33, 0.5);
      }

      & .close-modal:hover,
      & .close-modal:focus {
        color: rgba(26, 28, 33, 0.3);
        text-decoration: none;
        cursor: pointer;
      }

      & > p {
        overflow: auto;
        height: 100%;
      }
    }
  }
`;
